import { render, staticRenderFns } from "./ProductBlock.vue.html?vue&type=template&id=8670d914&scoped=true&"
import script from "./ProductBlock.component.js?vue&type=script&lang=vueJs&"
export * from "./ProductBlock.component.js?vue&type=script&lang=vueJs&"
import style0 from "./ProductBlock.scoped.scss?vue&type=style&index=0&id=8670d914&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8670d914",
  null
  
)

export default component.exports